module.exports = __webpack_public_path__ + "img/splash-conditionnement.6ba34899.jpg";